import { render, staticRenderFns } from "./proDetails.vue?vue&type=template&id=d862b7d2&scoped=true"
import script from "./proDetails.vue?vue&type=script&lang=js"
export * from "./proDetails.vue?vue&type=script&lang=js"
import style0 from "./proDetails.vue?vue&type=style&index=0&id=d862b7d2&prod&scoped=true&lang=css"
import style1 from "./proDetails.vue?vue&type=style&index=1&id=d862b7d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d862b7d2",
  null
  
)

export default component.exports